import { Component, OnInit, Input, SimpleChanges, OnChanges, OnDestroy} from '@angular/core';
import { Question } from '../shared/models/question';
import { AssessmentService } from '../shared/services/assessment.service';
import { Assessment } from '../shared/models/assessment';
import { ActivatedRoute } from '@angular/router';
import { ViewStateService } from '../../shared/services/view-state.service';
import { NotificationsService } from '../../shared/services/notifications.service';
import moment from 'moment';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-result-review',
  templateUrl: './result-review.component.html',
  styleUrls: ['./result-review.component.css']
})
export class ResultReviewComponent implements OnInit, OnDestroy {

  constructor( 
    private assessmentService: AssessmentService,  
    private route: ActivatedRoute,
    private viewState: ViewStateService, 
    private notifications: NotificationsService
  ) { }

  @Input() question: Question;
  @Input() totalQuestions: number;
  @Input() personId: string;
  currentYear: string;
  assessment: Assessment;
  assessmentResultId: string;
  questionId: string;
  message = "Check back next quarter to see how your performance compares to your peers."
    private destroy$ = new Subject<void>();


  ngOnInit() {    
    this.currentYear = moment(new Date).format('YYYY');
    this.route.params
  .pipe(takeUntil(this.destroy$))
  .subscribe(params => {
    this.assessmentResultId = params['assessmentResultId'];
    this.fetchAssessmentResult();
  });
  }

  private fetchAssessmentResult() {
    this.viewState.startLoading();
    this.assessmentService.fetchAssessmentResult(this.personId, this.assessmentResultId)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (res) => {
          this.assessment = res;
          this.viewState.stopLoading();
        },
        (errors) => {
          this.handleServerErrorResponse(errors);
          this.viewState.stopLoading();
        }
      );
  }

  private handleServerErrorResponse(response) {
    if (response.status === 500)
      {this.notifications.error("Unexpected Error", "An unexpected error occurred. Please try again or contact NBRC for assistance.");}
    else {
      const error = response;
      this.notifications.error('Error', error[0].message);
    }
    this.viewState.stopLoading();
  }

  printReferences() {
    const header =  '<header><img style="margin: 10px 0 30px 30px" src="/assets/images/logo.png" alt="NBRC logo" /></header><hr/>';
    const footer =  '<footer style="background-color: #2d2d2d; color: #fff; width: 100%; position: absolute; bottom: 0; left: 0;"><div style="padding: 1.5rem 1rem; margin-left: 20px;"><small>&copy;' + this.currentYear + '- The National Board of Respiratory Care</small></div></footer>';
    const body = '<div style="margin: 20px 0 20px 30px"><h2>Reference for ' + this.assessment.credentialCode + ' Quarter ' + this.assessment.assessmentSequence + ', Question ' + this.question.sequence + '</h2>' + this.question.reference + '</div>' ;
    const references = '<body style="margin: 0; font-family: Open Sans,sans-serif;">' + header + body + footer + '</body>';
    const newTab = window.open("", "_blank");
    newTab.document.write(references);
    newTab.onload = e => {
      newTab.print();
    };
    newTab.document.close();
    newTab.focus();
  }

  emailReferences() {
    this.questionId = this.question.options[0].questionId;
    this.assessmentService.getEmailReferenceDetail(this.personId, this.questionId)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (details) => {
          this.viewState.stopLoading();
          this.notifications.success("Success", "References emailed to address on file.");
        },
        (errors) => {
          const error = errors.error;
          if (error[0].fieldName === "questionId") {
            this.notifications.error("Error", "Question not started.");
          } else if (error[0].fieldName === "assessmentId") {
            this.notifications.error("Error", "Assessment not published.");
          } else if (error[0].fieldName === "assessmentGroup") {
            this.notifications.error("Error", "Not valid for the practitioner.");
          } else {
            this.notifications.error("Error", "No valid email on file.");
          }
        }
      );
  }

  getPercentage() {        
    return Math.round(this.question.pvalue * 100).toString();
  }
  get showMessage():boolean
  {
    return this.question.pvalue === null;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
